import { MEDIA_FIELDS } from './media'

export const META = `meta {
  title
  image {
    ${MEDIA_FIELDS}
  }
  description
}`
